import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  flex-grow: 1;
`;

export const Title = styled(Typography.Header)`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: center;
  margin-top: 20px;
  margin-bottom: 15px;
`;

export const Subtitle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;
`;
